import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { CHAT_DATA } from "./chatData";
import { useGame } from "../header/GameContext";
import "./chat.css";
import { useLocation } from "react-router-dom";

const ChatBoxType2 = forwardRef(function ChatBoxType2(
  {
    DateVal: propDateVal,
    titImgClass = "",
    chatClass = "chat_box4",
    onFinish,
    onButton,
  },
  ref,
) {
  const { TOTAL_GAME_TIME } = useGame();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleContents, setVisibleContents] = useState([]);
  const chatBoxRef = useRef(null);

  const location = useLocation();
  const state = location.state || {};
  const stateDateVal = state.DateVal;
  const DateVal = propDateVal || stateDateVal || "DATA1";

  /* =========================
     게임시간(분) — {{totalGameTime}} 치환용
  ========================= */
  const totalGameMin = Math.floor(
    (Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
      Number(TOTAL_GAME_TIME) ||
      0) / 60,
  );

  /* =========================
     데이터 + 치환
  ========================= */
  let rawContents = [];
  if (DateVal === "DATA1") rawContents = CHAT_DATA.dataArr01;
  else if (DateVal === "DATA2") rawContents = CHAT_DATA.dataArr02;
  else if (DateVal && CHAT_DATA[DateVal]) rawContents = CHAT_DATA[DateVal];

  const contents = rawContents.map((item) => ({
    ...item,
    text: item.text?.replace(/\{\{totalGameTime\}\}/g, String(totalGameMin)),
  }));

  /* 외부에서 resume 호출 가능 */
  useImperativeHandle(ref, () => ({
    resume() {
      setCurrentIndex((prev) => prev + 1);
    },
  }));

  /* =========================
     채팅 자동 진행
  ========================= */
  useEffect(() => {
    if (currentIndex >= contents.length) return;

    const item = contents[currentIndex];

    if (item.type === "button") {
      onButton && onButton(item);
      return;
    }

    const textLength = item.text ? item.text.length : 10;
    const delay = Math.min(120 + textLength * 12, 600);

    const t = setTimeout(() => {
      setVisibleContents((prev) => [...prev, item]);
      setCurrentIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(t);
  }, [currentIndex, contents, onButton]);

  /* =========================
     스크롤
  ========================= */
  useEffect(() => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTo({
      top: chatBoxRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [visibleContents]);

  return (
    <div className={`${chatClass} mt24`} id="chat_box" ref={chatBoxRef}>
      {visibleContents.map((c, i) => {
        if (c.type === "chatInfo_Talk1") {
          return (
            <div
              key={i}
              className={`chatInfo_Talk ${c.marType || ""}`}
              dangerouslySetInnerHTML={{ __html: c.text }}
            />
          );
        }

        if (c.type === "leftCharacter") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8">
                <span className={c.chat_icon}></span>
              </div>
              <div className="chat_b_l_right">
                <p className="chat_tit mb4">{c.chat_tit}</p>
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        if (c.type === "left_txt") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8" />
              <div className="chat_b_l_right">
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
});

export default ChatBoxType2;
